/**
 * Deterministik PRNG (mulberry32). Seed → har doim bir xil ketma-ketlik.
 * Talaba variantlarini generatsiya qilish uchun; Math.random ISHLATILMAYDI.
 */

export interface Rng {
  /** [0, 1) oraliqda */
  next(): number;
  /** [a, b) oraliqda tekis taqsimot */
  uniform(a: number, b: number): number;
  /** a..b (ikkalasi ham kiradi) butun son */
  int(a: number, b: number): number;
  /** Normal taqsimot (Box-Muller) */
  normal(mean: number, std: number): number;
  /** Massivdan tasodifiy element */
  pick<T>(items: readonly T[]): T;
  /** `step` ga yaxlitlangan tekis taqsimot, masalan uniform 0.5 qadam bilan */
  uniformStep(a: number, b: number, step: number): number;
}

/** Matnli seed'dan 32-bit son (FNV-1a). */
export function hashSeed(seed: string | number): number {
  if (typeof seed === 'number') return seed >>> 0;
  let h = 0x811c9dc5;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function createRng(seed: string | number): Rng {
  let a = hashSeed(seed);

  const next = (): number => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  return {
    next,
    uniform: (lo, hi) => lo + (hi - lo) * next(),
    int: (lo, hi) => lo + Math.floor(next() * (hi - lo + 1)),
    normal: (mean, std) => {
      let u = 0;
      let v = 0;
      while (u === 0) u = next();
      while (v === 0) v = next();
      return mean + std * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
    },
    pick: (items) => {
      if (items.length === 0) throw new Error('pick: empty array');
      return items[Math.floor(next() * items.length)] as (typeof items)[number];
    },
    uniformStep: (lo, hi, step) => {
      const n = Math.floor((hi - lo) / step);
      const k = Math.floor(next() * (n + 1));
      return lo + k * step;
    },
  };
}
